import { getBanks as getBanksApi } from '@musinsa/apis-curator';
import { lazyPipe } from '@musinsa/packages-functional';
import {
  validateServiceResponse,
  withServiceErrorCapture,
} from '@musinsa/services-common-service-zod4';

import type { GetBanksServiceResponse } from './getBanks.dto';
import { GetBanksServiceResponseSchema } from './getBanks.dto';

export const getBanksService = withServiceErrorCapture(
  lazyPipe(
    async (): Promise<GetBanksServiceResponse> => {
      const apiResponse = await getBanksApi();

      const serviceResponse: GetBanksServiceResponse = {
        banks: apiResponse.data.banks.map((bank) => ({
          displayName: bank.displayName,
          imageUrl: bank.imageUrl,
        })),
      };

      return serviceResponse;
    },

    validateServiceResponse(GetBanksServiceResponseSchema),
  ),
);
